import { Num, Obj, Str } from '@livecontrol/core-utils';
import jwtDecode from 'jwt-decode';

export interface Token {
  user: number;
  jwt: Token.JWT;
}

export namespace Token {
  export type JWT = string;

  /**
   * Decode the specified token.
   *
   * @param value - JWT to be decoded.
   * @returns Decoded token
   */
  export const decode = (value?: unknown): Token | undefined => {
    const jwt = Str.normalize(value);
    let token;

    if (jwt) {
      try {
        const obj = jwtDecode<Obj.Rec>(jwt);

        const candidate = {
          user: Num.normalize(obj.user_id),
          jwt
        };

        if (Obj.isHydrated(candidate)) {
          token = candidate;
        }
      } catch {
        // ignore
      }
    }

    return token;
  };
}
